import React from 'react';
import {Card, Dropdown} from "react-bootstrap";
import {useDispatch} from "react-redux";
import {
    openDeleteModal,
    openModal,
    updateItem
} from "../redux-store/installations";
import {AiFillEdit} from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import ellipsis from "../images/ellipsis-h.png";

const CustomDropDownToggle = React.forwardRef(({children, onClick}, ref) => (
    <button
        className={"btn"}
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </button>
));

const BootstrapCard = (props) => {
    const dispatch = useDispatch();
    const {name,description,id} = props.data

    const handleUpdateItem = (data) => {
        dispatch(openModal())
        dispatch(updateItem(data))
    }

    const handleOpenConfirmationModal = (id) => {
        dispatch(openDeleteModal(id))
    }

    return (
        <>
            <Card>
                <Card.Body>
                    <div className={"container p-unset"}>
                        <div className={"row"}>
                            <div className={"col-9 col-md-8 col-lg-6 col-xl-9"}>
                                <Card.Title>{name}</Card.Title>
                            </div>
                            <div className={"col-3 col-md-4 col-lg-6 col-xl-3 text-right card-option"}>
                                <Dropdown align="end">
                                    <Dropdown.Toggle as={CustomDropDownToggle} id="dropdown-custom-components">
                                        <img src={ellipsis} width={5} height={15} className={"ms-2"}/>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item eventKey="1" className={"update-button-card"} onClick={() => handleUpdateItem(props.data)}>
                                            <AiFillEdit /> Izmjeni
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="2" className={"delete-button-card"}
                                                       onClick={() => handleOpenConfirmationModal(id)}>
                                            <RiDeleteBin6Line/> Obriši
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className={"form-row align-items-center"}>
                            <div className="col-auto my-1">
                                <div className="custom-control custom-checkbox mr-sm-2">
                                    <p className={"card-p"}>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};
export default BootstrapCard;
